/**
 * Login Page
 * 
 * Simple login page with Twitch OAuth button.
 */

import { useAuth } from '@/hooks/useAuth'
import { Navigate } from 'react-router-dom'

export default function Login() {
  const { isAuthenticated, isLoading, login } = useAuth()
  
  // If already authenticated, redirect to dashboard
  if (isAuthenticated && !isLoading) {
    return <Navigate to="/" replace />
  }
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-app p-4">
      <div className="w-full max-w-md">
        {/* Logo/Title */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gradient mb-2">PratBot</h1>
          <p className="text-text-secondary">
            Modular Twitch chatbot with web administration
          </p>
        </div>
        
        {/* Login card */}
        <div className="card">
          <h2 className="text-xl font-semibold text-text-primary mb-6 text-center">
            Sign in to continue
          </h2>
          
          <button
            onClick={login}
            disabled={isLoading}
            className="w-full btn-primary py-3 text-lg flex items-center justify-center gap-3"
          >
            {isLoading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
            ) : (
              <>
                {/* Twitch logo */}
                <svg
                  className="w-6 h-6"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
                </svg>
                Sign in with Twitch
              </>
            )}
          </button>
          
          <p className="mt-6 text-center text-sm text-text-muted">
            By signing in, you agree to grant PratBot access to your Twitch account.
          </p>
        </div>
        
        {/* Footer */}
        <p className="mt-8 text-center text-sm text-text-muted">
          PratBot v0.1.0
        </p>
      </div>
    </div>
  )
}
